<template>
  <div class="dag" id="dag">
    <Badge :count="rechargeNum"  overflow-count='999'>
<!--      <a href="javascript:;" class="demo-badge" @click="trap('采集')">{{ $t('采集') }}</a>-->
      <Button type="primary" :loading="isCaiji" @click="caiji">采开奖</Button>
    </Badge>
    <Badge :count="withdrawNum"  overflow-count='999'>
      <Button type="primary" :loading="isMaking" @click="make">采新图</Button>
    </Badge>
    <Badge :count="withdrawNum"  overflow-count='999'>
      <Button type="primary" :loading="isCaijiZiliao" @click="caijiZiliao()">采资料</Button>
    </Badge>
    <Badge :count="onlineNum" overflow-count='999'>
      <Button type="primary" @click="openTestUrl">清缓存</Button>
    </Badge>
  </div>
</template>
<script>
// import { recharge, withdraw, online } from './title.js'
import {
  urlGet,
  urlEdit,
  customPost
} from '@/api/Lhc/Lhc'

export default {
  name: 'newtitle',
  inject: ['reload'],
  props: {},
  data () {
    return {
      isCaiji:false,
      isMaking:false,
      isCaijiZiliao:false,
      rechargeNum: 0,
      withdrawNum: 0,
      onlineNum: 0,
      size: null,
      timer: null,
      timer2: null,
      timer3: null,
      rechargeStste: false,
      withdrawStste: false,
      onlineStste: false,
      timeReload: '',
    }
  },
  mounted () {
    this.size = window.onresize = () => {
      return (() => {
        this.getWidth()
      })()
    }
  },
  created () {
    let vm=this;
  },
  watch: {
    // rechargeStste (newVal, Old) {
    //   if (newVal) {
    //     recharge().then(response => {
    //       if (response.data.code == 1) {
    //         this.rechargeNum = response.data.data.rechargeCount
    //         window.localStorage.setItem('recharge', this.rechargeNum)
    //         this.rechargeStste = false
    //       }
    //     })
    //   }
    // },
    // withdrawStste (newVal, Old) {
    //   if (newVal) {
    //     withdraw().then(response => {
    //       if (response.data.code == 1) {
    //         this.withdrawNum = response.data.data.withdrawCount
    //         window.localStorage.setItem('withdraw', this.withdrawNum)
    //         this.withdrawStste = false
    //       }
    //     })
    //   }
    // },
    // onlineStste (newVal, Old) {
    //   if (newVal) {
    //     online().then(response => {
    //       if (response.data.code == 1) {
    //         this.onlineNum = response.data.data.onlineCount
    //         window.localStorage.setItem('online', this.onlineNum)
    //         this.onlineStste = false
    //       }
    //     })
    //   }
    // }
  },
  methods: {
    caiji() {
      console.log('🚀 [采开奖] 开始执行采集操作')
      this.isCaiji = true;
      const startTime = Date.now()
      
      customPost('tuku/caiji', {}).then(response => {
        this.isCaiji = false;
        const duration = Date.now() - startTime
        
        console.log('📊 [采开奖] 执行完成，耗时:', duration + 'ms')
        console.log('📦 [采开奖] 完整响应数据:', response)
        console.log('📦 [采开奖] 响应状态:', response.status)
        console.log('📦 [采开奖] 响应数据:', response.data)
        
        if (response.data.success) {
          let successMsg = '采开奖成功'
          if (response.data.msg) {
            successMsg += '：' + response.data.msg
          }
          if (response.data.count !== undefined) {
            successMsg += ' (采集条数:' + response.data.count + ')'
          }
          if (response.data.data && response.data.data.length) {
            successMsg += ' (数据量:' + response.data.data.length + '条)'
          }
          
          this.$Message.success({
            content: successMsg,
            duration: 8
          })
          
          // 弹出详细成功信息
          this.$Modal.success({
            title: '✅ 采开奖成功详情',
            content: '<div style="max-height:400px;overflow:auto;"><pre>' + JSON.stringify(response.data, null, 2) + '</pre></div>',
            width: 600
          })
          
          console.log('✅ [采开奖] 操作成功完成')
        } else {
          // 显示详细错误信息
          let errorMsg = '采开奖失败：' + (response.data.msg || '未知错误')
          if (response.data.code !== undefined) {
            errorMsg += ' [代码:' + response.data.code + ']'
          }
          if (response.data.error) {
            errorMsg += ' [详情:' + response.data.error + ']'
          }
          
          this.$Message.error({
            content: errorMsg,
            duration: 10
          })
          
          // 弹出详细错误对话框
          this.$Modal.error({
            title: '❌ 采开奖详细错误信息',
            content: '<div style="max-height:400px;overflow:auto;"><pre>' + JSON.stringify(response.data, null, 2) + '</pre></div>',
            width: 600
          })
          
          console.error('❌ [采开奖] 操作失败:', response)
        }
      }).catch(error => {
        this.isCaiji = false;
        let errorMsg = '采开奖失败：'
        if (error.response && error.response.data && error.response.data.msg) {
          errorMsg += error.response.data.msg
        } else if (error.message) {
          errorMsg += error.message
        } else {
          errorMsg += '网络请求错误'
        }
        this.$Message.error(errorMsg)
        console.error('采开奖网络错误：', error)
      })
    },
    make() {
      console.log('🚀 [采新图] 开始执行采集操作')
      this.isMaking = true;
      const startTime = Date.now()
      
      customPost('tuku/make', {}).then(response => {
        this.isMaking = false;
        const duration = Date.now() - startTime
        
        console.log('📊 [采新图] 执行完成，耗时:', duration + 'ms')
        console.log('📦 [采新图] 完整响应数据:', response)
        console.log('📦 [采新图] 响应状态:', response.status)
        console.log('📦 [采新图] 响应数据:', response.data)
        
        if (response.data.success) {
          let successMsg = '采新图成功'
          if (response.data.msg) {
            successMsg += '：' + response.data.msg
          }
          if (response.data.count !== undefined) {
            successMsg += ' (采集条数:' + response.data.count + ')'
          }
          if (response.data.data && response.data.data.length) {
            successMsg += ' (数据量:' + response.data.data.length + '条)'
          }
          if (response.data.images !== undefined) {
            successMsg += ' (图片数量:' + response.data.images + '张)'
          }
          
          this.$Message.success({
            content: successMsg,
            duration: 8
          })
          
          // 弹出详细成功信息
          this.$Modal.success({
            title: '✅ 采新图成功详情',
            content: '<div style="max-height:400px;overflow:auto;"><pre>' + JSON.stringify(response.data, null, 2) + '</pre></div>',
            width: 600
          })
          
          console.log('✅ [采新图] 操作成功完成')
        } else {
          // 显示详细错误信息
          let errorMsg = '采新图失败：' + (response.data.msg || '未知错误')
          if (response.data.code !== undefined) {
            errorMsg += ' [代码:' + response.data.code + ']'
          }
          if (response.data.error) {
            errorMsg += ' [详情:' + response.data.error + ']'
          }
          
          this.$Message.error({
            content: errorMsg,
            duration: 10
          })
          
          // 弹出详细错误对话框
          this.$Modal.error({
            title: '❌ 采新图详细错误信息',
            content: '<div style="max-height:400px;overflow:auto;"><pre>' + JSON.stringify(response.data, null, 2) + '</pre></div>',
            width: 600
          })
          
          console.error('❌ [采新图] 操作失败:', response)
        }
      }).catch(error => {
        this.isMaking = false;
        let errorMsg = '采新图失败：'
        if (error.response && error.response.data && error.response.data.msg) {
          errorMsg += error.response.data.msg
        } else if (error.message) {
          errorMsg += error.message
        } else {
          errorMsg += '网络请求错误'
        }
        this.$Message.error(errorMsg)
        console.error('采新图网络错误：', error)
      })
    },
    caijiZiliao(){
      console.log('🚀 [采资料] 开始执行采集操作')
      this.isCaijiZiliao = true;
      const startTime = Date.now()
      
      customPost('tuku/make', {op:'ziliao'}).then(response => {
        this.isCaijiZiliao = false;
        const duration = Date.now() - startTime
        
        console.log('📊 [采资料] 执行完成，耗时:', duration + 'ms')
        console.log('📦 [采资料] 完整响应数据:', response)
        console.log('📦 [采资料] 响应状态:', response.status)
        console.log('📦 [采资料] 响应数据:', response.data)
        console.log('📦 [采资料] 请求参数: op=ziliao')
        
        if (response.data.success) {
          let successMsg = '采资料成功'
          if (response.data.msg) {
            successMsg += '：' + response.data.msg
          }
          if (response.data.count !== undefined) {
            successMsg += ' (采集条数:' + response.data.count + ')'
          }
          if (response.data.data && response.data.data.length) {
            successMsg += ' (数据量:' + response.data.data.length + '条)'
          }
          if (response.data.materials !== undefined) {
            successMsg += ' (资料数量:' + response.data.materials + '条)'
          }
          
          // 简单的成功通知
          this.$Message.success({
            content: successMsg,
            duration: 5
          })
          
          // 在控制台静默显示详细采集数据
          console.log('✅ [采资料] 操作成功完成')
          console.log('📈 [采集统计] 总数量:', response.data.count || 0)
          console.log('📈 [采集统计] 资料数量:', response.data.materials || 0)
          
          if (response.data.data && typeof response.data.data === 'object') {
            console.log('📋 [详细数据] 采集详情:')
            Object.keys(response.data.data).forEach(key => {
              console.log(`  - ${key}: ${response.data.data[key]} 条`)
            })
          }
          
          console.log('🎯 [采集完整数据]', response.data)
        } else {
          // 显示详细错误信息
          let errorMsg = '采资料失败：' + (response.data.msg || '未知错误')
          if (response.data.code !== undefined) {
            errorMsg += ' [代码:' + response.data.code + ']'
          }
          if (response.data.error) {
            errorMsg += ' [详情:' + response.data.error + ']'
          }
          
          this.$Message.error({
            content: errorMsg,
            duration: 10
          })
          
          // 弹出详细错误对话框
          this.$Modal.error({
            title: '❌ 采资料详细错误信息',
            content: '<div style="max-height:400px;overflow:auto;"><pre>' + JSON.stringify(response.data, null, 2) + '</pre></div>',
            width: 600
          })
          
          console.error('❌ [采资料] 操作失败:', response)
        }
      }).catch(error => {
        this.isCaijiZiliao = false;
        let errorMsg = '采资料失败：'
        if (error.response && error.response.data && error.response.data.msg) {
          errorMsg += error.response.data.msg
        } else if (error.message) {
          errorMsg += error.message
        } else {
          errorMsg += '网络请求错误'
        }
        this.$Message.error(errorMsg)
        console.error('采资料网络错误：', error)
      })
    },
    openTestUrl() {
      let vm = this
      customPost('tuku/flushAll', {}).then(response => {
        this.isMaking = false;
        this.$Message.success(response.data.msg)
      })
    },

    getWidth () {
      let width = document.body.offsetWidth
      let dag = document.getElementById('dag')
      if (width < 980) {
        dag.style.display = 'none'
      } else  {
        dag.style.display = 'block'
      }
    },
    trap (val) {
      this.$router.push({
        name: val
      })
    }
    // getRecharge () {
    //   if (this.timer) {
    //     clearTimeout(this.timer)
    //   }
    //   let rechargeList = window.localStorage.getItem('recharge')
    //   if (!rechargeList) {
    //     recharge().then(response => {
    //       if (response.data.code == 1) {
    //         this.rechargeNum = response.data.data.rechargeCount
    //         window.localStorage.setItem('recharge', this.rechargeNum)
    //       }
    //     })
    //   } else {
    //     this.rechargeNum = Number(rechargeList)
    //   }
    //   if (new Date().getDate() === 1) {
    //     this.timeReload = window.localStorage.getItem('timeReload')
    //     if (this.timeReload == 0) {
    //       window.localStorage.setItem('timeReload', 1)
    //       setTimeout(() => {
    //         location.reload()
    //       }, 2000)
    //     }
    //   } else {
    //     window.localStorage.setItem('timeReload', 0)
    //   }
    //   this.timer = setTimeout(() => {
    //     this.rechargeStste = true
    //     this.getRecharge()
    //   }, 10000)
    //
    // },
    // getWithdraw () {
    //   if (this.timer2) {
    //     clearTimeout(this.timer2)
    //   }
    //   let withdrawList = window.localStorage.getItem('withdraw')
    //   console.log('aa', withdrawList)
    //   if (!withdrawList && withdrawList != 'undefined') {
    //     console.log('xx')
    //     withdraw().then(response => {
    //       console.log('xx', response)
    //       if (response.data.code == 1) {
    //
    //         this.withdrawNum = response.data.data.withdrawCount
    //
    //         window.localStorage.setItem('withdraw', this.withdrawNum)
    //       }
    //     })
    //   } else {
    //     this.withdrawNum = Number(withdrawList)
    //   }
    //   this.timer2 = setTimeout(() => {
    //     // window.localStorage.setItem("rechargeTime",true)
    //     this.withdrawStste = true
    //     this.getWithdraw()
    //   }, 10000)
    // },
    // getOnline () {
    //   if (this.timer3) {
    //     clearTimeout(this.timer3)
    //   }
    //   let onlineList = window.localStorage.getItem('online')
    //   if (!onlineList) {
    //     online().then(response => {
    //       if (response.data.code == 1) {
    //         this.onlineNum = response.data.data.onlineCount
    //         window.localStorage.setItem('online', this.onlineNum)
    //       }
    //       // let timerthree = setTimeout(() => {
    //       //     this.getOnline()
    //       // },30000)
    //     })
    //   } else {
    //     this.onlineNum = Number(onlineList)
    //   }
    //   this.timer3 = setTimeout(() => {
    //     // window.localStorage.setItem("rechargeTime",true)
    //     this.onlineStste = true
    //     this.getOnline()
    //   }, 20000)
    // }
  }
}
</script>
<style lang="less">
@import './title.less';
</style>
